export default __webpack_public_path__ + "media/images/open-graph-image-82e3eeeb9e7b27eb58ce4d3b1adb7d24.jpg";